import {
  Swiper, Navigation, Pagination, Lazy,
} from 'swiper';

function positionNavigation(slide, classBlock) {
  const indexCurrentSlide = slide.realIndex;
  const currentSlide = slide.el.querySelector(`.slide__${indexCurrentSlide}`);
  if (!currentSlide) {
    return;
  }
  const currentImageDescription = currentSlide.querySelector(`${classBlock}__image-description`);
  const sliderPagination = slide.el.querySelector(`${classBlock}__pagination `);

  if (sliderPagination) {
    if (currentImageDescription) {
      sliderPagination.style.alignItems = 'start';
    } else {
      sliderPagination.style.alignItems = 'center';
    }
  }
}

export function initSlider(container) {
  // eslint-disable-next-line no-new
  return new Swiper(`${container}__swiper`, {
    slidesPerView: 1,
    grabCursor: true,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        autoHeight: false,
        spaceBetween: 0,
      },
    },
    autoHeight: true,
    loop: true,
    centeredSlides: true,
    modules: [Navigation, Pagination, Lazy],
    navigation: {
      nextEl: `${container}__button--next`,
      prevEl: `${container}__button--prev`,
    },
    pagination: {
      el: `${container}__pagination`,
      type: 'custom',
      renderCustom(swiper, current, total) {
        return `<span>${current}</span> &mdash; <span >${total}</span>`;
      },
    },
    on: {
      activeIndexChange() {
        positionNavigation(this, container);
      },
      afterInit() {
        if (this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length === 1) {
          this.allowTouchMove = false;
          this.unsetGrabCursor();
          this.el.querySelector(`${container}__navigation-position`).style.visibility = 'hidden';
        } else {
          this.el.querySelectorAll('.swiper-slide').forEach((slide) => {
            slide.addEventListener('click', () => {
              if (slide.classList.contains('swiper-slide-prev')) {
                this.slidePrev();
              }
              if (slide.classList.contains('swiper-slide-next')) {
                this.slideNext();
              }
            });
          });
        }
      },
    },
  });
}
